import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import React, { useState } from 'react';
import SelectPopup from '../../../../Components/SelectPopup';
import FilterPopup from '../../../../Components/FilterPopup';
import { indexToPromoFilter } from '../../../../Utils/constants';

export default function PromoPlatFilter({ value, onChangeValue }) {
  const [internalSelect, setInternalSelect] = useState(value);
  const filterValue = indexToPromoFilter(internalSelect);

  const onOpen = () => {
    setInternalSelect(value);
  };

  return (
    <SelectPopup
      value={internalSelect === -1 ? 'All' : `${filterValue.platform} - ${filterValue.promo}`}
      label="Promotion Type"
      inputStyle={{ minWidth: { xs: '100px', sm: '13rem' }, maxWidth: '13rem' }}
      onOpenPopup={onOpen}
    >
      <FilterPopup
        boxStyle={{
          padding: 2,
        }}
        onApply={() => {
          onChangeValue(internalSelect);
          return true;
        }}
      >
        <Box sx={{ height: 'max-content', width: '100%' }}>
          <FormControl fullWidth>
            <RadioGroup
              value={internalSelect}
              onChange={(event) => setInternalSelect(parseInt(event.target.value, 10))}
              sx={{
                '& .MuiFormControlLabel-root': {
                  py: { xs: 0.75, sm: 0.5 },
                  '& .MuiRadio-root': {
                    padding: { xs: 1.5, sm: 1 },
                  },
                },
                '& .MuiFormLabel-root': {
                  mt: { xs: 1.5, sm: 1 },
                  mb: { xs: 0.5, sm: 0.25 },
                  fontWeight: 'bold',
                  fontSize: { xs: '0.95rem', sm: '1rem' },
                },
              }}
            >
              <FormControlLabel value={-1} control={<Radio />} label="All" />

              <FormLabel focused={false}>TikTok</FormLabel>
              <FormControlLabel value={0} control={<Radio />} label="Sound Promotion" />
              <FormControlLabel value={1} control={<Radio />} label="Brand Promotion" />

              <FormLabel focused={false}>Instagram</FormLabel>
              <FormControlLabel value={2} control={<Radio />} label="Sound Promotion (Reel)" />
              <FormControlLabel value={3} control={<Radio />} label="Brand Promotion (Reel)" />
              <FormControlLabel value={4} control={<Radio />} label="Feed Promotion" />
              <FormControlLabel value={5} control={<Radio />} label="Story Promotion" />

              <FormLabel focused={false}>YouTube</FormLabel>
              <FormControlLabel value={6} control={<Radio />} label="Integrated Promotion" />
              <FormControlLabel value={7} control={<Radio />} label="Shorts" />
              <FormControlLabel value={8} control={<Radio />} label="Dedicated Video" />

              <FormLabel focused={false}>Podcasts</FormLabel>
              <FormControlLabel value={9} control={<Radio />} label="Pre-roll ad" />
              <FormControlLabel value={10} control={<Radio />} label="Mid-roll ad" />
              <FormControlLabel value={11} control={<Radio />} label="Post-roll ad" />
              <FormControlLabel value={12} control={<Radio />} label="Full episode Sponsorship" />

              <FormLabel focused={false}>Twitch</FormLabel>
              <FormControlLabel value={13} control={<Radio />} label="Product Placement" />

              <FormLabel focused={false}>Kick</FormLabel>
              <FormControlLabel value={14} control={<Radio />} label="Product Placement" />

              <FormLabel focused={false}>X (Twitter)</FormLabel>
              <FormControlLabel value={15} control={<Radio />} label="Feed Post" />
              <FormControlLabel value={16} control={<Radio />} label="Repost" />
            </RadioGroup>
          </FormControl>
        </Box>
      </FilterPopup>
    </SelectPopup>
  );
}
